export enum MspCategoryDigitCodesEnum {
  NON_EXIST,
  MICRO,
  SMALL,
  NORMAL,
}
